"use strict";

// global-polyfill (resolving "global is not defined" issue)
(function () {
  try {
    // Attempt to access `global` directly to see if it's defined
    if (typeof globalThis.global === 'undefined') {
      // Polyfill `global` in browser-like environments
      globalThis.global = globalThis;
    }
  } catch (e) {
    // If `global` is not defined or throws an error (e.g., strict mode or a sandbox env)
    window.global = window;
  }
})();